// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2BUO0","log":"ModalInventoryLogs_log__1p_le","date":"ModalInventoryLogs_date__27Sj9","userName":"ModalInventoryLogs_userName__14huy"};